import { render, staticRenderFns } from "./Detalhamento.vue?vue&type=template&id=d2f1b6b8&scoped=true"
import script from "./Detalhamento.vue?vue&type=script&lang=js"
export * from "./Detalhamento.vue?vue&type=script&lang=js"
import style0 from "./Detalhamento.vue?vue&type=style&index=0&id=d2f1b6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f1b6b8",
  null
  
)

export default component.exports